import { Alert, styled, Typography, Button } from '@mui/material';
import { ReactComponent as Logo } from 'images/pkd-logo.svg';
import { Link } from 'react-router-dom';

export const UnblockEmailWrapper = styled('div')(({ theme }) => ({
  display                        : 'flex',
  flexDirection                  : 'column',
  justifyContent                 : 'center',
  alignItems                     : 'center',
  backgroundRepeat               : 'no-repeat',
  backgroundSize                 : 'cover',
  width                          : '100vw',
  height                         : '100vh',
  background                     : '#f9f9f9',
  [theme.breakpoints.down('sm')] : {
    backgroundRepeat : 'no-repeat',
    backgroundSize   : 'cover',
  },
}));

export const Container = styled('div')(({ theme }) => ({
  width                          : '375px',
  backgroundColor                : theme.palette.primary.white,
  boxShadow                      : '0px 0px 30px rgba(0, 84, 135, 0.05)',
  borderRadius                   : '8px',
  padding                        : '40px',
  boxSizing                      : 'border-box',
  [theme.breakpoints.down('sm')] : {
    backgroundColor : 'transparent',
    boxShadow       : 'none',
    borderRadius    : '0px',
  },
}));

export const TitleContainer = styled('div')(() => ({
  display        : 'flex',
  justifyContent : 'center',
  alignItems     : 'center',
  textAlign      : 'center',
  marginBottom   : '5px',
}));

export const Row = styled('div')(({ marginBottom }) => ({
  display        : 'flex',
  justifyContent : 'center',
  alignItems     : 'center',
  textAlign      : 'center',
  marginBottom   : marginBottom || '20px',
}));

export const ButtonContainer = styled('div')(() => ({
  display        : 'flex',
  justifyContent : 'center',
  alignItems     : 'center',
  textAlign      : 'center',
  paddingTop     : 10,
}));

export const AcmeLogo = styled(Logo)({
  width  : '102px',
  height : '70px',
});

export const PageTitle = styled(Typography)(({ theme }) => ({
  color      : theme.palette.primary.darkGray100,
  fontFamily : 'inherit',
  fontStyle  : 'normal',
  fontWeight : 600,
  fontSize   : '24px',
  lineHeight : '140%',
  textAlign  : 'center',
}));

export const HelperText = styled(Typography)(({ theme }) => ({
  color      : theme.palette.primary.darkGray70,
  fontSize   : '14px',
  textAlign  : 'center',
  lineHeight : '140%',
}));

export const FormContainer = styled('div')({
  paddingTop              : '25px',
  width                   : '300px',
  position                : 'relative',
  '& .MuiInputBase-input' : {
    paddingRight : '40px !important',
  },
});

export const BackLink = styled(Link)(({ theme }) => ({
  color          : theme.palette.primary.fuchsia75,
  textDecoration : 'none',
}));

export const StyledAlert = styled(Alert)(({ theme }) => ({
  background   : theme.palette.white,
  borderRadius : '8px',
  boxShadow    : '1px 1px 4px rgba(0, 0, 0, 0.1);',
  alignItems   : 'center',
}));

export const UnblockButton = styled(Button)(({ theme }) => ({
  background    : theme.palette.primary.white,
  color         : theme.palette.primary.fuchsia75,
  border        : '1px solid',
  borderColor   : theme.palette.primary.fuchsia75,
  borderRadius  : 2,
  padding       : '15px 15px 15px 15px',
  marginTop     : '20px',
  width         : '130px',
  height        : '40px',
  fontWeight    : 'bold',
  fontSize      : '14px',
  textTransform : 'none',
  '&: hover'    : {
    background : theme.palette.primary.white,
  },
}));
